import React from 'react';
import styled from 'styled-components/macro';
import { translations } from '../../../../locales/translations';
import { useSelector } from 'react-redux';
import { selectOtherReimbursement } from '../slice/selectors';
import { LoadingIndicator } from '../../../components/LoadingIndicator';
import { Table, TableBody, TableContainer, TableHead, TableRow } from '@mui/material';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { useTranslation } from 'react-i18next';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';

function booleanToImage(value) {
  return value ? <CheckOutlinedIcon /> : <CloseOutlinedIcon />;
}

export function OtherReimbursementItems() {
  const { t } = useTranslation();
  const reimbursementData = useSelector(selectOtherReimbursement);
  const rows = [
    {
      id: 1,
      item: t(translations.contractDetail.table.governmentRentRate),
      reimbursedByCustomer: booleanToImage(
        reimbursementData?.governmentRentRate,
      ),
      remark: reimbursementData?.governmentRentRateRemark,
    },
    {
      id: 2,
      item: t(translations.contractDetail.table.electricityCharge),
      reimbursedByCustomer: booleanToImage(
        reimbursementData?.electricityCharge,
      ),
      remark: reimbursementData?.electricityChargeRemark,
    },
    {
      id: 3,
      item: t(translations.contractDetail.table.stampDuty),
      reimbursedByCustomer: booleanToImage(reimbursementData?.stampDuty),
      remark: reimbursementData?.stampDutyRemark,
    },
  ];

  return (
    <Wrapper>
      {reimbursementData ? (
        <div>
          <TableContainer className='table-container'>
            <Table sx={{ minWidth: 700 }} size='small'>
              <TableHead>
                <TableRow>
                  <StyledTableCell className='first-header'>
                    {t(translations.contractDetail.table.items)}
                  </StyledTableCell>
                  <StyledTableCell className='second-header'>
                    {t(translations.contractDetail.table.reimbursedByCustomer)}
                  </StyledTableCell>
                  <StyledTableCell>
                    {t(translations.contractDetail.table.remark)}
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map(row => (
                  <StyledTableRow key={row.id}>
                    <StyledTableCell>{row.item}</StyledTableCell>
                    <StyledTableCell align='center'>
                      {row.reimbursedByCustomer}
                    </StyledTableCell>
                    <StyledTableCell>{row.remark}</StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      ) : (
        <LoadingIndicator />
      )}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  background: ${p => p.theme.containerBackground};
  font-size: 12px;
  border-radius: 5px;

  .table-container {
    border-radius: 5px;
    box-shadow: 1px 2px ${p => p.theme.borderLight};
  }

  .first-header {
    min-width: 180px;
  }

  .second-header {
    min-width: 180px;
    text-align: center;
  }
`;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.primary,
    color: theme.background,
    fontSize: 12,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.backgroundVariant,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));
